import React, {useEffect, useRef} from 'react';
import {LoaderPrototipeIconSize} from '../icon_types';

type LoaderPrototipeIconProps = {
  id?: string;
  className?: string;
  size: LoaderPrototipeIconSize;
  color?: string;
};

const pathDsBySize = {
  '24': [
    'M12.5 2V6',
    'M12.5 18V22',
    'M5.42969 4.92969L8.25969 7.75969',
    'M16.7383 16.2383L19.5683 19.0683',
    'M2.5 12H6.5',
    'M18.5 12H22.5',
    'M5.42969 19.0683L8.25969 16.2383',
    'M16.7383 7.75969L19.5683 4.92969',
  ],
  '40': [
    'M20 3.33334V10',
    'M20 30V36.6667',
    'M8.2168 8.21667L12.9335 12.9333',
    'M27.0669 27.0667L31.7836 31.7833',
    'M3.3335 20H10.0002',
    'M30 20H36.6667',
    'M8.2168 31.7833L12.9335 27.0667',
    'M27.0669 12.9333L31.7836 8.21667',
  ],
};

const loaderStrokeWidths = {
  '24': '2.66667',
  '40': '3.33333',
};

const LoaderPrototipeIcon = (
  props: React.PropsWithChildren<LoaderPrototipeIconProps>,
) => {
  const {id, className, size, color} = props;
  const paths = pathDsBySize[size];
  const strokeWidth = loaderStrokeWidths[size];
  const svgRef = useRef<SVGSVGElement>(null);
  const colorOptions = color || 'currentColor' || '#1E1E20';

  useEffect(() => {
    let rotationDegree = 0;
    let animationFrame: any;

    const rotate = () => {
      rotationDegree = (rotationDegree + 1) % 360;
      if (svgRef.current) {
        svgRef.current.style.transform = `rotate(${rotationDegree}deg)`;
      }
      animationFrame = requestAnimationFrame(rotate);
    };

    animationFrame = requestAnimationFrame(rotate);

    return () => cancelAnimationFrame(animationFrame);
  }, []);

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: size,
        height: size,
      }}>
      <svg
        id={id}
        className={className}
        ref={svgRef}
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        fill="none">
        {paths.map((d, index) => (
          <path
            key={index}
            d={d}
            stroke={colorOptions}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeOpacity={1 - index * 0.08}
          />
        ))}
      </svg>
    </div>
  );
};

export default LoaderPrototipeIcon;
